import { render, staticRenderFns } from "./PerguntasFrequentes.vue?vue&type=template&id=32c63542&scoped=true"
import script from "./PerguntasFrequentes.vue?vue&type=script&lang=js"
export * from "./PerguntasFrequentes.vue?vue&type=script&lang=js"
import style0 from "./PerguntasFrequentes.vue?vue&type=style&index=0&id=32c63542&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c63542",
  null
  
)

export default component.exports